import type { AxiosRequestConfig, AxiosResponse } from "axios"
import axios from "axios"
import { getAssetServiceDomain } from "../constants"

export const preferencesAxios = axios.create({
  baseURL: getAssetServiceDomain(),
  paramsSerializer: {
    indexes: null,
  },
})

/**
 * Axios instance for Orval generated Preferences API client, not meant to be used directly.
 */
export const preferencesAxiosGenInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  return preferencesAxios
    .request<T, AxiosResponse<T>>({
      ...config,
      ...options,
    })
    .then(({ data }) => data)
}
